<template>
 <div class="appie-loader">
<!--   <video class="mobile_video" autoplay loop muted playsinline >-->
<!--     <source src="https://d1n38xan9p5vaa.cloudfront.net/web-assets/nloader.webm" type="video/webm"/>-->
<!--     <source src="https://d1n38xan9p5vaa.cloudfront.net/web-assets/nloader.mp4" type="video/mp4"/>-->

<!--   </video>-->
   <img src="@/assets/nithra_loading.gif" alt="loading" class="mobile_video">
<!--   <dotlottie-player-->
<!--       src="https://lottie.host/df87769a-bfe9-4eb1-90ff-3193cbeced30/cxytmGt070.json"-->
<!--       background="transparent"-->
<!--       speed="1"-->
<!--       style="width: 300px; height: 300px;"-->
<!--       loop-->
<!--       autoplay-->
<!--   ></dotlottie-player>-->
<!--<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">-->
<!--<circle cx="50" cy="50" r="0" fill="none" stroke="#e90c59" stroke-width="2">-->
<!--  <animate attributeName="r" repeatCount="indefinite" dur="1s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="0s"></animate>-->
<!--  <animate attributeName="opacity" repeatCount="indefinite" dur="1s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="0s"></animate>-->
<!--</circle><circle cx="50" cy="50" r="0" fill="none" stroke="#46dff0" stroke-width="2">-->
<!--  <animate attributeName="r" repeatCount="indefinite" dur="1s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.5s"></animate>-->
<!--  <animate attributeName="opacity" repeatCount="indefinite" dur="1s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.5s"></animate>-->
<!--</circle>-->
<!--&lt;!&ndash; [ldio] generated by https://loading.io/ &ndash;&gt;</svg>-->
 </div>
</template>

<script>
export default {
  name: 'LottieAnimation'

};
</script>

<style type="text/css">
.appie-loader {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.mobile_video{
  height: 40%;
}

/* generated by https://loading.io/ */
</style>
